import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';

import { reducerVisitScheduleTrainee } from "../../../redux/reducer/userSingleReport/reducers/visitSchedule";
import { AppDispatch } from "../../../redux/reducer/store";

import CircleLoader from "../../../components/custom/circleLoader/circleLoader";
import SectionContent from "../../../components/sectionContent/sectionContent";
import VisitSchedule from "../../../pages/visitSchedule/visitSchedule";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const CustomerSingleReportSection: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { data } = useSelector((state: IUserOptions) => state.user.user);
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  const { visitReportsCount } = useSelector(
    (state: any) => state.userSingleReport.visitSchedule
  );

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleChangeTraineeFilter = () => {
    dispatch(reducerVisitScheduleTrainee(!isChecked));
    setIsChecked(!isChecked);
  };

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        section="График посещений"
        pageName="reports"
        headBlockChildren={
          ((data.isCustomer || (claims && (claims.includes('admin') || claims.includes('schedule:export')))) && <HeaderBtn
            content="Выгрузить в excel"
            purpose="unloadScheduleExcel"
            modalTitle="Выгрузить в excel"
            hasIcon='excel'
          />)
        }
        headBlockFilters={
          <div className="visit__trainee_block">
            <input type="checkbox" onClick={handleChangeTraineeFilter} />
            <span>Стажер</span>
          </div>
        }
      >
        <div className="content__main">
          <div className="btns">
            <div className="tab">
              <div className="buttons__btn --active">
                Всего
                <div className="tab__reports_count">
                  {!visitReportsCount && visitReportsCount !== 0 ? (
                    <CircleLoader />
                  ) : (
                    visitReportsCount
                  )}
                </div>
              </div>
            </div>
            {((data.isCustomer && data?.settings?.posMap) || (claims?.length > 0 && (claims.includes('admin') || claims.includes('pos:map:view'))))
             && <Link to={'/map'} className="buttons__btn tab__reports_btn">Карта обслуживания</Link>}
          </div>
          <VisitSchedule />
        </div>
      </SectionContent>
    </div>
  );
};

export default CustomerSingleReportSection;
